import { Routes } from '../../constants'
import {
    BlueAccolades,
    BlueOEL,
    BlueOffers,
    BluePromos,
    BlueQH,
    BlueVariants,
    BlueTicketSizes,
} from './icons'

const Pages = [{
        path: Routes.SELF_SERVE_PROMOS,
        icon: BluePromos,
        isDisabled: false,
        i18nKey: 'self-serve-promos',
    }, {
        path: Routes.SELF_SERVE_CREDITS,
        icon: BlueOffers,
        isDisabled: false,
        i18nKey: 'self-serve-credits',
    }, {
        path: Routes.SELF_SERVE_TICKET_SIZES,
        icon: BlueTicketSizes,
        isDisabled: false,
        i18nKey: 'self-serve-ticket-sizes',
    }, {
        path: Routes.SELF_SERVE_ACCOLADES,
        icon: BlueAccolades,
        isDisabled: true,
        i18nKey: 'self-serve-accolades',
    }, {
        path: Routes.SELF_SERVE_VARIANTS,
        icon: BlueVariants,
        isDisabled: false,
        i18nKey: 'self-serve-variants',
    }, {
        path: Routes.SELF_SERVE_QUIET_HOURS,
        icon: BlueQH,
        isDisabled: true,
        i18nKey: 'self-serve-quiet-hours',
    }, {
        path: Routes.SELF_SERVE_OEL,
        icon: BlueOEL,
        isDisabled: true,
        i18nKey: 'self-serve-oel',
    },
]

export default Pages
